import axios from "../axios";

export default async (data, isThankYouPage = false) => {
  let timeout = 0;
  // eslint-disable-next-line no-unused-expressions
  isThankYouPage ? (timeout = 120000) : (timeout = 5000);
  const response = await axios({
    method: "get",
    url: `${process.env.SERVER_URL}/facebook-pixels`,
    params: {
      myshopifyDomain: data.myshopifyDomain,
      productIds: data.productIds,
    },
    timeout,
  });
  console.log(response.data);
  return response.data;
};
